import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const AgreementExpiredDetails = ({ partner }) => (
    <Page heading="Avtaleforslaget har gått ut på tid">
        <div>
            <p>
                Be {partner.name} å sende et nytt avtaleforslag hvis du ønsker å
                fortsette handelen.
            </p>

            <div className="r-phl r-ptl">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
        </div>
    </Page>
);

AgreementExpiredDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(AgreementExpiredDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/agreementExpiredDetails.jsx